import { SpcParserError } from "./SpcParserError.js";
import { getFallbackDecoder } from "./decodeText.js";
import { validateTimeZone } from "./timeZone.js";
/**
 * Creates the parse context for one `parse` call.
 * @param options - the options given to `parse`.
 * @returns A fresh context with an empty warning list.
 * @throws {TypeError} When `options.encoding` is not a supported encoding, or
 * `options.timeZone` is not a supported zone.
 */
export function createParseContext(options = {}) {
    const { encoding = 'windows-1252', strict = false, sortX = true, timeZone, logger, } = options;
    try {
        getFallbackDecoder(encoding);
    }
    catch (error) {
        throw new TypeError(`Unsupported encoding option: "${encoding}"`, {
            cause: error,
        });
    }
    if (timeZone !== undefined)
        validateTimeZone(timeZone);
    const warnings = [];
    return {
        warnings,
        strict,
        encoding,
        sortX,
        timeZone,
        warn(message) {
            logger?.warn(message);
            if (strict)
                throw new SpcParserError('STRICT', message);
            warnings.push(message);
        },
    };
}
//# sourceMappingURL=ParseContext.js.map